var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowToLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.54038 5.45962C0.286539 5.20578 0.286539 4.79422 0.54038 4.54038L4.67696 0.403807C4.9308 0.149966 5.34235 0.149966 5.59619 0.403807C5.85003 0.657647 5.85003 1.0692 5.59619 1.32305L1.91924 5L5.59619 8.67696C5.85003 8.9308 5.85003 9.34235 5.59619 9.59619C5.34235 9.85004 4.9308 9.85004 4.67696 9.59619L0.54038 5.45962ZM19 5.65L1 5.65L1 4.35L19 4.35L19 5.65Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToLeft);
export default __webpack_public_path__ + "static/media/arrow_toLeft.430d757914f212dc224d74ea844b2251.svg";
export { ForwardRef as ReactComponent };